import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-ing_ia',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ing_ia.component.html',
  styleUrls: ['./ing_ia.component.css']
})
export class Ing_iaComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}